import { Question, Send, Spark } from "@scoach/ui/icons";
import { useState } from "react";

import { LiveTipsPanel } from "../../../meeting/live/components/LiveTipsPanel.tsx";
import { QuietBar } from "../../../meeting/live/components/QuietBar.tsx";
import { TranscriptView } from "../../../meeting/live/components/TranscriptView.tsx";
import { useLiveMeetingStore } from "../../../meeting/live/store.ts";
import { QuestionChecklist } from "./QuestionChecklist.tsx";
import { ScorecardPanel } from "./ScorecardPanel.tsx";

/**
 * Interview right column, split 50/50:
 *  - top half: a tabbed area — "Ask questions" (interactive checklist) and
 *    "Transcript" (like before);
 *  - bottom half: the live Score and Tips, stacked, scrolling together.
 */
export function InterviewRightPanel({ meetingId }: { meetingId: string }) {
  const [tab, setTab] = useState<"ask" | "transcript" | "quickask">("ask");
  const listening = useLiveMeetingStore((s) => s.listening);
  const muted = useLiveMeetingStore((s) => s.muted);

  return (
    <section
      className="panel transcript-panel"
      style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, gap: 8 }}
    >
      {/* Top 50%: tabbed Ask questions / Transcript */}
      <section
        className="panel"
        style={{ flex: "1 1 50%", minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <div className="panel-head">
          <div className="seg seg-sm right-tab-seg">
            <button
              type="button"
              className={tab === "ask" ? "on" : ""}
              onClick={() => setTab("ask")}
            >
              <Question size={13} /> Ask questions
            </button>
            <button
              type="button"
              className={tab === "transcript" ? "on" : ""}
              onClick={() => setTab("transcript")}
            >
              Transcript
              {listening && !muted && (
                <span
                  className="rec-dot"
                  title="Recording"
                  aria-label="Recording"
                  style={{ marginLeft: 6 }}
                />
              )}
            </button>
            <button
              type="button"
              className={tab === "quickask" ? "on" : ""}
              onClick={() => setTab("quickask")}
            >
              <Send size={13} /> Quick ask
            </button>
          </div>
        </div>
        {tab === "ask" ? (
          <div className="scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
            <QuestionChecklist />
          </div>
        ) : tab === "transcript" ? (
          <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <TranscriptView />
          </div>
        ) : (
          <div className="scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
            <QuietBar meetingId={meetingId} />
          </div>
        )}
      </section>

      {/* Bottom 50%: live Score + Tips stacked, scrolling together */}
      <div
        className="scroll"
        style={{
          flex: "1 1 50%",
          minHeight: 0,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <ScorecardPanel meetingId={meetingId} />
        <section className="panel" style={{ minHeight: 0 }}>
          <div className="panel-head">
            <div className="seg seg-tabs" style={{ pointerEvents: "none", width: "100%" }}>
              <button type="button" className="on">
                <Spark size={14} /> Tips
              </button>
            </div>
          </div>
          <div className="fu-scroll">
            <LiveTipsPanel />
          </div>
        </section>
      </div>
    </section>
  );
}
